import type { PathLookupEventTopic } from '@ipfabric/utils';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import { toggleArrayElement } from 'utils/array/toggleArrayElement';

interface TogglePathLookupEventTopicCommand {
  topic: PathLookupEventTopic;
}

export const togglePathLookupEventTopic: GraphCommandFactory<
  TogglePathLookupEventTopicCommand
> = (cmdContext) => (command) => {
  cmdContext.updateState((draft) => {
    const pathLookupDraft = draft.pathlookup.presetDraft.pathLookup;
    pathLookupDraft.ignoredTopics = toggleArrayElement(command.topic)(
      pathLookupDraft.ignoredTopics,
    );
  });
};
